'use client'

import { MainRoutes } from '@/utils/routes'
import { Link } from '@/components/ui/link'
import { LogOut } from 'lucide-react'
import { usePostHog } from 'posthog-js/react'
import { useState } from 'react'
import LoadingSpinner from '@/components/ui/loading-spinner'
import { cn } from '@/lib/css-utils'

interface LogoutLinkProps {
  hasIcon?: boolean
  className?: string
}

export function LogoutLink({ className, hasIcon = true }: LogoutLinkProps) {
  const posthog = usePostHog()
  const [isLoading, setIsLoading] = useState(false)

  return (
    <Link
      href={MainRoutes.Logout}
      prefetch={false}
      onClick={() => {
        setIsLoading(true)
        posthog.reset(true)
      }}
      className={cn(
        'flex text-sm font-medium gap-2 text-copy-accent justify-start',
        className,
      )}
    >
      {isLoading ? <LoadingSpinner /> : hasIcon ? <LogOut /> : null} Logout
    </Link>
  )
}
